const prodConfig = {
  baseUrl: 'https://node.dimorder.com/c/merchant/landing?from=landing&l=zh',
}

export default prodConfig
